import type { SelectOption } from '@presentation/components';
import { useCallback, useState } from 'react';

export interface UseSearchInputParams<TValue> {
  initialValue?: TValue;
}

export const useSearchInput = <TValue>(params: UseSearchInputParams<TValue>) => {
  const {} = params;

  const [value, setValue] = useState<TValue | undefined>(params.initialValue);
  const [tempValue, setTempValue] = useState<TValue | undefined>();
  const [inputValue, setInputValue] = useState<string>();

  const onSelect = useCallback((selected: SelectOption<TValue> | undefined) => {
    setTempValue(selected?.value ?? undefined);
    setInputValue(selected?.label?.toString() ?? undefined);
    setValue(selected?.value ?? undefined);
  }, []);

  const onSearchChange = useCallback((newValue?: string) => {
    setInputValue(newValue);
  }, []);

  return {
    value: tempValue ?? value,
    search: inputValue,
    onSearchChange,
    onSelect,
  };
};
